import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//

export default {
  name: 'widget__score',
  props: {
    power: Number
  },
  computed: {
    stars: function stars() {
      var starsArr = [];
      var power = this.power / 10;
      while (power > 0) {
        if (power >= 1) {
          starsArr.push('full');
        } else if (power === 0.5) {
          starsArr.push('half');
        } else {
          starsArr.push('');
        }
        power--;
      }
      return starsArr;
    }
  }
};